import React, { Component } from 'react';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';
import Dropzone from 'react-dropzone';
import { FILEPICKER_KEY } from '../constants';
import actions from '../redux/actions';

class ImageUploader extends Component {
  filepicker = null;

  constructor(props) {
    super(props);
    this.state = {
      imagePreviewUrl: '',
      dropzoneActive: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { image } = nextProps;

    if (this.props.image !== image) {
      this.setState({ imagePreviewUrl: image });
    }
  }

  componentDidMount() {
    this.filepicker = require('filepicker-js');
    this.filepicker.setKey(FILEPICKER_KEY);
  }

  onDragEnter() {
    this.setState({
      dropzoneActive: true,
    });
  }

  onDragLeave() {
    this.setState({
      dropzoneActive: false,
    });
  }

  onDrop(files, rejected) {
    this.setState({
      dropzoneActive: false,
    });

    this.props.hideAlert();
    if (rejected.length) {
      this.props.alert(
        'success',
        'Please upload only .jpeg and .png image files.'
      );
      return;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
      this.setState({
        imagePreviewUrl: reader.result,
      });
    };

    reader.readAsDataURL(files[0]);

    this.filepicker.store(
      files[0],
      (FPFile) => {
        this.setState({
          imagePreviewUrl: FPFile.url,
        });
        this.props.onUpload(FPFile);
        this.props.alert('success', 'Upload successful!');
      },
      (FPError) => {
        console.error(FPError);
        this.props.alert(
          'error',
          'Oops! Your upload has failed. Please try again.'
        );
      }
    );
  }

  _handleClick(e) {
    e.preventDefault();
    this.props.hideAlert();

    this.filepicker.pick(
      {
        extensions: ['.png', '.jpg', '.jpeg'],
        container: 'modal',
        openTo: 'COMPUTER',
        maxSize: 1024 * 1024,
      },
      (FPFile) => {
        this.setState({
          imagePreviewUrl: FPFile.url,
        });
        this.props.onUpload(FPFile);
        this.props.alert('success', 'Upload success!');
      },
      (FPError) => {
        console.error(FPError);
        this.props.alert('error', 'Upload failed!');
      }
    );
  }

  _handleImageRemove(e) {
    e.preventDefault();

    this.setState({
      file: null,
      imagePreviewUrl: '',
    });

    this.props.onUpload(null);
  }

  render() {
    const { imagePreviewUrl, dropzoneActive } = this.state;
    const dropStyle = {
      width: '100%',
      height: '100%',
      border: 0,
    };

    return (
      <div className="img-upload">
        <div className="img-wrapper">
          {imagePreviewUrl ? (
            <a className="remove" onClick={(e) => this._handleImageRemove(e)}>
              <FontAwesome name="close" />
            </a>
          ) : null}
          <div
            className={`img-preview ${dropzoneActive && 'active'}`}
            onClick={(e) => this._handleClick(e)}
          >
            {imagePreviewUrl ? (
              <img src={imagePreviewUrl} role="presentation" />
            ) : (
              <Dropzone
                accept="image/jpeg, image/png"
                multiple={false}
                disableClick={true}
                style={dropStyle}
                onDrop={(files, rejected) => this.onDrop(files, rejected)}
                onDragEnter={() => this.onDragEnter()}
                onDragLeave={() => this.onDragLeave()}
              >
                <span>Drop file here.</span>
              </Dropzone>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
});

export default connect(null, mapDispatchToProps)(ImageUploader);



// WEBPACK FOOTER //
// src/components/ImageUploader.jsx